// noinspection ES6UnusedImports
import * as bootstrap from 'bootstrap';

require('./app/service_worker_installer');
require('./app/history_state');
require('./app/alpine.js');
require('./app/notifications');
require('./app/home_navigation');
require('./app/section');
require('./app/back_button');
require('./app/install_banner');

console.log('theme.js initialized');
